import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link , useNavigate} from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { io } from 'socket.io-client';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { toast, ToastContainer } from 'react-toastify';
import { timeAgo } from "./components/timeAgo";
 

function FamilyNewsfeed() {
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

  const navigate = useNavigate();
 
  const { data: newsfeed = [], isLoadingFeeds, isErrorFeeds } = useQuery({
    queryKey: ['familyNewsfeed'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/get-family-newsfeed-api`,
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        return res.data.listings;
      }
  
      throw new Error("Failed to fetch newsfeed");
    },
    staleTime: 0,
    cacheTime: Infinity,
  });


  return (
    
    <div className="scrollPageContainer theme-light">
            <div className="main-wrapper">
                {isSidebarVisible && <Sidebar />}
                <Header toggleSidebar={toggleSidebar} />
                <Sidebar show={showSidebar} toggle={toggleSidebar} />
                <Footerbar toggleSidebar={toggleSidebar} />

                 <ToastContainer />
                
                <div className="page-wrapper">
                    <div className="content container-fluid"> 



 
 <div class="row">
 <div className="col-md-12">
 <div className="card soft-radius border-0 shadow-sm mb-3 home-card gallery-card newsfeed-widget">
   <div className="card-body p-3">
     {/* header */}
     <div className="d-flex justify-content-between align-items-start mb-2">
       <div className="d-flex align-items-center gap-2">
         <span className="chip chip-green">
           <i className="fas fa-rss" />
         </span>
         <div>
           <h6 className="fw-bold mb-0 small-title">Family newsfeed</h6>
           
         </div>
       </div>
        
        
     </div>
 
     {isLoadingFeeds ? (
       <div className="loadingspinnerDiv">
         <div className="loadingspinner"></div>
       </div>
     ) : isErrorFeeds ? (
       <p className="text-muted small mb-0">Failed to load newsfeed.</p>
     ) : newsfeed.length === 0 ? (
       <p className="text-muted small mb-0">No newsfeed available.</p>
     ) : (
       newsfeed.map((item, index) => {
         const initials = `${item.name?.[0] || ""}${item.last_name?.[0] || ""}`.toUpperCase();
         const colorClass = `avatar-color-${index % 3}`;
 
         return (
           <div className="newsfeed-card" key={index}>
             <div className="newsfeed-user">
               {item.image_name ? (
                 <img
                   src={`${API_URL}/images/${item.image_name}`}
                   alt={item.name}
                   className="newsfeed-avatar"
                 />
               ) : (
                 <div className={`newsfeed-avatar newsfeed-avatar-initials ${colorClass}`}>
                   {initials}
                 </div>
               )}
               <div className="newsfeed-content">
                 <div className="newsfeed-text">
                   <span className="newsfeed-name">
                     {item.name} {item.last_name}
                   </span>{" "}
                   {item.newsfeed}
                 </div>
                 <div className="newsfeed-date">
                   {timeAgo(item.date_time)}
                 </div>
               </div>
             </div>
           </div>
         );
       })
     )}
   </div>
 </div>
 
   </div>
   </div>


   </div>
   </div>
   </div>


   

   <style>{`
   :root {
  --green-deep: #0d6e28;
  --green-lime: #75b437;
  --green-forest: #184a2c;
  --white: #ffffff;
}

.newsfeed-widget {
  background: var(--white);
  border: 1px solid #e9f3ec;
}

.newsfeed-widget .small-title {
  color: var(--green-forest);
  font-size: 0.95rem;
}

.newsfeed-widget .extra-small {
  color: #6b8a75 !important;
}

/* header icon chip */


.see-all-link {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--green-deep);
  text-decoration: none;
  white-space: nowrap;
}
.see-all-link:hover {
  color: var(--green-forest);
  text-decoration: underline;
}

/* list rows */
.newsfeed-card {
  padding: 10px 0;
  border-bottom: 1px solid #eef4ef;
}
.newsfeed-card:last-child {
  border-bottom: none;
}

.newsfeed-user {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

/* avatar (image or initials) */
.newsfeed-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid var(--white);
  box-shadow: 0 0 0 1px #dcebe0;
}

.newsfeed-avatar-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--white);
}

/* rotate through your palette for initials backgrounds */
.avatar-color-0 { background: var(--green-deep); }
.avatar-color-1 { background: var(--green-lime); }
.avatar-color-2 { background: var(--green-forest); }

.newsfeed-content {
  flex: 1;
  min-width: 0;
}

.newsfeed-text {
  font-size: 0.85rem;
  line-height: 1.4;
  color: #33473b;
}

.newsfeed-name {
  font-weight: 700;
  color: var(--green-forest);
}

.newsfeed-date {
  font-size: 0.72rem;
  color: var(--green-lime);
  font-weight: 600;
  margin-top: 2px;
}

/* loading spinner tint */
.loadingspinner {
  border-top-color: var(--green-deep) !important;
}


 

    `}</style>


    </div>
  );
}

  

export default FamilyNewsfeed;
